// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__245fF","dragIcon":"SortableItem_dragIcon__2Kjj1","disabled":"SortableItem_disabled__2VBWc"};